import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import isEmail from 'validator/lib/isEmail';
import classNames from 'classnames';

import TextField from '@material-ui/core/TextField';

import GDPRHint from '../GDPRHint';
import { FormattedMessageWrappedInSpan } from '../../misc';


const ENTER_KEY = 'Enter';

const translations = defineMessages({
  emailTextFieldPlaceholder: {
    id: 'requestRecheckView.emailTextField.placeholder',
    defaultMessage: 'Enter your email address',
  },
  emailTextFieldLabel: {
    id: 'requestRecheckView.emailTextField.label',
    defaultMessage: 'Email',
  },
});

const RequestRecheckView = ({ intl, isStartNumberInputDisabled, onCancel, ...props }) => {

  const [email, setEmail] = useState(props.email || '')
  const [emailIsInvalid, setEmailIsInvalid] = useState(false)
  const [startNumber, setStartNumber] = useState(props.startnumber || '')
  const [startNumberIsInvalid, setStartNumberIsInvalid] = useState(false)


  const handleStartnumberChanged = event => {
    setStartNumber(event.target.value.replace(/ /gi, ''));
    setStartNumberIsInvalid(false);
  };

  const handleEmailChanged = event => {
    setEmail(event.target.value);
    setEmailIsInvalid(false);
  };

  const handleKeyPressed = (event, value) => {
    if (event.key === ENTER_KEY) {
      submitForm();
    }
  };

  const validateInput = () => {
    // For a few weeks now (as of september 4th 2019), users have been increasingly
    // entering their e-mail address instead of their starting number. Since the causes
    // for the problem are not fully understandable, I check if there is an e-mail address
    // entered in the start number field.

    if (startNumber === '' || startNumber && isEmail(startNumber)) {
      setStartNumberIsInvalid(true);
      setStartNumber('');
      return false;
    }

    if (email === '' || email && !isEmail(email)) {
      setEmail('');
      setEmailIsInvalid(true);
      return false;
    }

    return true;
  };

  const submitForm = () => {

    if (validateInput()) {
      props.onSubmit(startNumber, email);
    }
  };

  return (
    <div className="notification-container">
      <div className="notification-body">
        {!isStartNumberInputDisabled && (
          <h1>
            <FormattedMessageWrappedInSpan
              id="requestRecheckView.dialogTitle"
              defaultMessage="Tag this photo with your start number"
            />
          </h1>
        )}
        {!isStartNumberInputDisabled && (
          <div
            className={classNames('notification-start-number-label', {
              error: startNumberIsInvalid,
            })}
          >
            <FormattedMessageWrappedInSpan
              id="requestRecheckView.startNumberLabel"
              defaultMessage="Enter your start number (alphanumeric)"
            />
          </div>
        )}
        {!isStartNumberInputDisabled && (
          <div className="startnumber-search-textfield">
            <div>
              <input
                autoComplete="off"
                autoFocus={startNumber === ''}
                disabled={isStartNumberInputDisabled}
                onChange={handleStartnumberChanged}
                onKeyPress={handleKeyPressed}
                placeholder="0000"
                value={startNumber || ''}
              />
            </div>
          </div>
        )}
        {isStartNumberInputDisabled && (
          <h1>
            <FormattedMessageWrappedInSpan
              id="requestRecheckView.searchByFace.dialogTitle"
              defaultMessage="Tag this photo"
            />
          </h1>
        )}
        {isStartNumberInputDisabled && (
          <input
            autoComplete="off"
            autoFocus={startNumber === ''}
            disabled={isStartNumberInputDisabled}
            hidden={isStartNumberInputDisabled}
            onChange={handleStartnumberChanged}
            onKeyPress={handleKeyPressed}
            placeholder="0000"
            value={startNumber || ''}
          />
        )}
        <TextField
          autoFocus={startNumber !== ''}
          className={classNames('notification-input', 'email-search-textfield')}
          error={emailIsInvalid}
          label={intl.formatMessage(translations.emailTextFieldLabel)}
          onChange={handleEmailChanged}
          onKeyPress={handleKeyPressed}
          placeholder={intl.formatMessage(translations.emailTextFieldPlaceholder)}
          value={email || ''}
        />
        <div className="mt-20">
          <GDPRHint />
        </div>
      </div>
      <div className="notification-action">
        <button onClick={onCancel}>
          <FormattedMessageWrappedInSpan
            id="requestRecheckView.cancelButton"
            defaultMessage="Cancel"
          />
        </button>
        <button
          className={classNames('accept')}
          onClick={submitForm}
        >
          <FormattedMessageWrappedInSpan
            id="requestRecheckView.acceptButton"
            defaultMessage="Submit"
          />
        </button>
      </div>
    </div>
  );

}

RequestRecheckView.defaultProps = {
  isStartNumberInputDisabled: false,
};

RequestRecheckView.propTypes = {
  isStartNumberInputDisabled: PropTypes.bool,
  startnumber: PropTypes.string,
  email: PropTypes.string,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  intl: PropTypes.object,
};

export default injectIntl(RequestRecheckView);
